import React from 'react'
import { makeStyles, createStyles } from '@material-ui/core/styles'

import type { ITheme } from '@homeviews/styles'
import { MediaCore } from '@homeviews/media'
import { Typography, WindowTitle } from '@homeviews/shared-ui'
import { Box } from '@material-ui/core'

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    root: {
      padding: theme.spacing(
        theme.layout.contentHorizontalPadding,
        theme.layout.contentVerticalPadding,
      ),
    },
  }),
)
const Media: React.FC = () => {
  const classes = useStyles()
  return (
    <>
      <WindowTitle title="Media" />
      <div className={classes.root}>
        <Typography variant="h1">Your Media</Typography>
        <Box mb={3}>
          <Typography>
            Here you can upload any media that will appear live on your pages.
            You will also find all of your previously uploaded images.
          </Typography>
        </Box>
        <MediaCore
          libraryType="images"
          header="Select from your media"
          formats="png, jpg, svg, gif"
        />
      </div>
    </>
  )
}

export default Media
